<template>
  <div>
    <breadcrumbs home="Supplier"/>

      <v-card flat>
        <v-form v-model="valid" ref="form">

          <v-tabs class="full-height-tab" show-arrows>
            <v-tab>Info</v-tab>
            <v-tab-item>
              <v-container class="pt-6 px-6" fluid>
                <v-row dense>
                  <v-col cols="12" sm="5">
                    <v-text-field label="Name" v-model="supplier.name" :rules="[fieldRules.required,fieldRules.maxLength(100)]" :counter="100" outlined dense/>
                  </v-col>
                  <v-col cols="2" md="1">
                    <v-checkbox label="Active" v-model="supplier.active" class="mt-1"/>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="5">
                    <v-text-field label="Email" v-model="supplier.email" :rules="[fieldRules.email,fieldRules.maxLength(100)]" :counter="100" outlined dense/>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="6" sm="3">
                    <v-text-field label="Phone" v-model="supplier.phone" :rules="[fieldRules.phone,fieldRules.maxLength(30)]" :counter="20" outlined dense/>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="8" sm="4" lg="3">
                    <v-checkbox v-model="supplier.suppliesInBond" dense label="Supplies alcohol in-bond" class="mb-4"/>
                  </v-col>
                  <v-col cols="6" sm="3">
                    <v-text-field v-if="supplier.suppliesInBond" v-model="supplier.license" outlined dense label="License number" :rules="[fieldRules.maxLength(20)]" :counter="20"/>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="6" sm="2" v-if="multiCurrency">
                    <v-autocomplete v-model="supplier.currency" outlined dense label="Currency" :disabled="supplierId!=undefined"
                                    :items="currencies" item-text="code" item-value="code"/>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="6">
                    <v-text-field label="Notes" v-model="supplier.notes" outlined dense :rules="[fieldRules.maxLength(200)]" :counter="200"/>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab>Address</v-tab>
            <v-tab-item>
              <v-container class="pt-6 px-6" fluid>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field label="Line 1" v-model="supplier.billingAddress.line1" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense/>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field label="Line 2" v-model="supplier.billingAddress.line2" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense/>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="8" sm="3">
                    <v-text-field label="City" v-model="supplier.billingAddress.city" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense/>
                  </v-col>
                  <v-col cols="4" sm="1">
                    <v-text-field label="Province" v-model="supplier.billingAddress.province" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense/>
                  </v-col>
                  <v-col cols="4" sm="2">
                    <v-text-field label="Postal code" v-model="supplier.billingAddress.postalCode" :rules="[fieldRules.maxLength(20)]" :counter="20" outlined dense/>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab>Contacts</v-tab>
            <v-tab-item>
              <contacts :contacts="supplier.contacts" @validate="$nextTick(() => $refs.form.validate())"/>
            </v-tab-item>
          </v-tabs>
        </v-form>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>


<script>
import confirmLeave from '@/mixins/confirmLeave'
import Contacts from '@/views/sales/customers/Contacts'

export default {
  name: 'PurchasingSuppliersEdit',
  mixins: [confirmLeave],
  components: {Contacts},
  props: {
    supplierId: {type:String, required:false}
  },
   data () {
    return {
      tab: null,
      suppliers: [],
      supplierType: 0,
      supplier: {name:'',active:true,
                 billingAddress: {line1:'',line2:'',city:'',province:'',postalCode:'',country:''},
                 phone:'',email:'',currency:'',notes:'',
                 suppliesInBond:false,license:'',contacts:[]},
      currencies: [],
      dirty: false,
      valid: true,
      saving: false,
      loading: false
    }
  },
  computed: {
    multiCurrency() {
      return this.$store.getters.company.settings.multiCurrency;
    }
  },
  watch: {
    supplier: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },

  async created() {
    const results = await this.$apiCall(`query PurchasingSuppliersEdit($id:ID!, $edit:Boolean!, $multiCurrency:Boolean!) {
                                              company @include(if:$multiCurrency) {
                                                currencies {
                                                  code
                                                }
                                              }
                                              vendor(id:$id) @include(if:$edit) {
                                                id,
                                                name,active,suppliesInBond,license,
                                                email,phone,currency,
                                                billingAddress {line1,line2,city,province,postalCode,country}
                                                contacts {name,title,email,phone}
                                                notes
                                              }
                                            }`,
                                        {id:this.supplierId||'',edit:this.supplierId!=undefined,multiCurrency:this.multiCurrency});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }
    this.currencies = [{code:this.$store.getters.company.settings.homeCurrency}];
    if (this.multiCurrency)
      this.currencies = this.currencies.concat(results.data.company.currencies);
    if (this.supplierId) {
      this.supplier = results.data.vendor;
    }
    else {
      this.supplier.currency = this.currencies[0].code;
      this.$nextTick(() => this.$refs.form.validate());
    }
    this.$nextTick(() => {this.dirty = false});
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      const input = {...this.supplier};
      if (this.supplierId)
        delete input.currency;
      const results = await this.$apiCall(`mutation PurchasingSuppliersEdit($input: VendorInput!) {
                                             vendorCreate(input:$input) {id}
                                           }`,
                                          {input});
      this.saving = false;
      if (!results.error)
        this.$nextTick(() => {
          this.dirty = false;
          this.$router.back();
          this.$store.commit('setError', {type:'success',message:`${this.supplierId?'Updated':'Created'} supplier ${this.supplier.name}`});
        });
    }
  }
}
</script>